import { styled } from '@mui/system';

import { IconCircleLoader } from 'assets/icons';

const CircleLoaderAnimation = styled('div')(({ theme, ...props }) => ({
  display: 'inline-block',
  color: theme.palette.texts.darkIcons,
  height: 24,
  animation: `spin ${props.sec}s linear infinite`,
  "@keyframes spin": {
    "0%": {
      transform: 'rotate(0deg)'
    },
    "100%": {
      transform: 'rotate(360deg)'
    }
  }
}));

const CircleLoader = ({ sec = 2 }) => {
  return (
    <CircleLoaderAnimation sec={sec}>
      <IconCircleLoader />
    </CircleLoaderAnimation>
  );
}

export default CircleLoader;
